import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from 'lib/utils'
import './checkbox.css'

export interface CheckboxProps {
	checked?: boolean
	onCheckedChange?: (checked: boolean) => void
	className?: string
	style?: React.CSSProperties
	id?: string
	name?: string
	disabled?: boolean
	'aria-label'?: string
	'aria-labelledby'?: string
}

const Checkbox = React.forwardRef<HTMLDivElement, CheckboxProps>(
	({ checked = false, onCheckedChange, className, style, id, disabled = false, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy }, ref) => {
		const handleClick = () => {
			if (!disabled && onCheckedChange) {
				onCheckedChange(!checked)
			}
		}

		return (
			<div
				ref={ref}
				role="checkbox"
				aria-checked={checked ? 'true' : 'false'}
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
				id={id}
				tabIndex={0}
				onClick={handleClick}
				onKeyDown={(e) => {
					if (e.key === ' ' || e.key === 'Enter') {
						e.preventDefault()
						handleClick()
					}
				}}
				className={cn('checkbox', checked && 'checkbox-checked', disabled && 'checkbox-disabled', className)}
				style={style}
			>
				{checked && <Check style={{ width: '12px', height: '12px', strokeWidth: 3, color: '#ffffff' }} />}
			</div>
		)
	},
)
Checkbox.displayName = 'Checkbox'

export { Checkbox }
